// extracted by mini-css-extract-plugin
module.exports = {"footnotes":"_23zF9","footnote":"_3ckvm"};